export const dashboardRoutesDefinitions = {
  home: {
    path: 'dashboard',
    name: 'dashboardHome'
  },
  faq: {
    path: 'faq',
    name: 'dashboardFaq'
  }
};
